module.exports = __webpack_public_path__ + "static/media/1-6.d6b5eca2.mp3";